import { Box, TableBody, TextField, ToggleButton, alpha } from '@mui/material'
import { CheckWeekDay } from '../views/ScheduleView/ScheduleView'
import { StyledMasonryTileTitle } from './MasonryStyles'
import { styled } from '@mui/system'
import { HolidayChecker } from '../store/utils/holidaysUtils'

export const StyledScheduleTitle = styled(StyledMasonryTileTitle)(({ theme }) => ({
  color: theme.palette.text.highEmphasis,
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
}))

export const StyledScheduleStickyTitle = styled(StyledScheduleTitle)(({ theme }) => ({
  pt: '8px',
  position: 'sticky',
  top: theme.spacing(-4),
  backgroundColor: theme.palette.background.elevation1,
  zIndex: 100,
  height: 'auto',
  minHeight: '46px',
  alignItems: 'flex-start',
}))

export const StyledHoursDisplay = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
}))

type SheduleStyledTableBodyProps = {
  date: string
  isSelected: boolean
  isOpen: boolean
  applyHoverStyles: boolean
}

export const StyledScheduleTableBody = styled(TableBody, {
  shouldForwardProp: prop => prop !== 'isSelected' && prop !== 'isOpen' && prop !== 'date',
})<SheduleStyledTableBodyProps>(({ theme, ...props }) => ({
  ':hover': {
    backgroundColor: props.isSelected
      ? props.isOpen
        ? 'transparent'
        : alpha(theme.palette.primary.main, 0.25)
      : props.isOpen
      ? 'transparent'
      : alpha(theme.palette.primary.main, 0.25),
  },
  backgroundColor: HolidayChecker({ date: props.date, month: props.date })
    ? props.isOpen
      ? 'transparent'
      : theme.palette.grey[100]
    : CheckWeekDay(props.date)
    ? props.isOpen
      ? 'transparent'
      : 'transparent'
    : props.isOpen
    ? 'transparent'
    : theme.palette.grey[100],
}))

// DIALOG
export const StyledScheduleDialogNumberInput = styled(TextField)(({ theme, ...props }) => ({
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& .MuiInputBase-root': {
    width: 50,
    height: 40,
  },
  backgroundColor: props.disabled ? theme.palette.grey[200] : 'transparent',
}))

export const StyledScheduleDialogDay = styled(ToggleButton)(({ theme, ...props }) => ({
  width: 20,
  height: 20,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '52px',
  padding: '14px',
  border: 'none',
  transition: 'all 150ms ease-in-out',
}))
